
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { uiStore, configStore } from "@/store/store";
import { Breakpoint } from "@/types/breakpoints";
import {
  BASE_BREAKPOINT_ID,
  customBreakpointIcon,
  DEVICE_ICONS
} from "@/lib/breakpoints/breakpoints";
import IconButton from "@/components/UI/IconButton.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: {
    Icon,
    Dropdown,
    IconButton
  }
})
export default class BreakpointsSelection extends Vue {
  @Prop()
  value!: Breakpoint;

  getDeviceIcon(breakpointId: string) {
    return DEVICE_ICONS[breakpointId]?.icon || customBreakpointIcon;
  }

  getDeviceIconRotation(breakpointId: string) {
    return DEVICE_ICONS[breakpointId]?.rotate;
  }

  get isBase() {
    return this.currentBreakpoint.id === BASE_BREAKPOINT_ID;
  }

  get breakpoints() {
    return configStore.breakpoints;
  }

  get currentBreakpoint() {
    return this.value;
  }

  get builderMode() {
    return configStore.builderMode;
  }

  activeClass(breakpointId: string) {
    return this.currentBreakpoint.id === breakpointId
      ? "breakpoint-active"
      : false;
  }

  changeBreakpoint(breakpoint: Breakpoint) {
    this.$emit("input", breakpoint);
  }

  @Watch("breakpoints", {
    deep: true,
    immediate: true
  })
  onBreakpointsChanged() {
    if (!this.breakpoints.find(b => b.id === this.currentBreakpoint.id)) {
      // select base breakpoint since the selected one before isn't present anymore
      uiStore.selectBaseBreakpoint();
    }
  }
}
